import { toastConfig } from 'config';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { Box, Grid, Stack, Typography } from '@mui/material';
import MainCard from 'components/MainCard';
import { useTheme } from '@mui/material/styles';
import { validateInput } from 'pages/globals/global';
import { CaretLeftOutlined } from '@ant-design/icons';
import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import comptroller from 'assets/images/comptroller_white.svg';
import ComptrollerConfirmModal from '../ComptrollerConfirmModal';
import { Button, Col, Flex, Form, Input, Row, Select } from 'antd';
import { useAddKmaMutation, useUpdateKmaMutation } from 'store/features/comptroller/comptrollerApi';
import { useGetModuleListMutation, useGetVerticalListMutation } from 'store/features/process/processApi';

const titleFormat = (code, name) => {
	return `${code} - ${name}`;
};

function COEKeyManagementArea() {
	const theme = useTheme();
	const state = useLocation();
	const [form] = Form.useForm();
	const navigate = useNavigate();

	const [activate, setActivate] = useState(true);
	const [subModule, setSubModule] = useState([]);
	const [modalInfo, setModalInfo] = useState(null);
	const [showModal, setShowModal] = useState(false);
	const [submitData, setSubmitData] = useState(null);
	const [navigateTo, setNavigateTo] = useState(null);
	const [submitForm, setSubmitForm] = useState(false);
	const [kmaListOption, setKmaListOption] = useState([]);
	const [moduleOptions, setModuleOptions] = useState([]);
	const [submitExcelData, setSubmitExcelData] = useState(null);
	const [stateValues, setStateValues] = useState({
		kmaDetails: null,
		solutionTable: [],
		kmaList: [],
	});
	const [counter, setCounter] = useState({
		name: 0,
		moduleId: 0,
		subModuleId: 0,
		parentKAMId: 0,
	});

	const { kmaDetails, kmaList } = stateValues;

	const { name, moduleId, subModuleId, parentKAMId } = counter;

	const { profileData = {} } = useSelector((state) => state?.profile);

	const [addKma, { data: newKmaRes }] = useAddKmaMutation();
	const [updateKma, { data: updateKmaRes }] = useUpdateKmaMutation();
	const [getModuleList, { data: moduleList }] = useGetModuleListMutation();
	const [getVerticalList, { data: verticalList }] = useGetVerticalListMutation();

	const onChange = useCallback(
		(val) => {
			const arr = [];

			for (let i = 0; i < moduleList?.listLynProcessModule?.length; i++) {
				if (moduleList?.listLynProcessModule[i]?.activationStatus === 'Active' && moduleList?.listLynProcessModule[i]?.parent === val) {
					arr.push(moduleList?.listLynProcessModule[i]);
				}
			}

			setSubModule(arr);
			form.setFieldValue('subModuleId', '');
		},
		[moduleList]
	);

	const handleExcel = async (excelDataParam) => {
		for (let i = 0; i < excelDataParam.length; i++) {
			// let obj = {
			//   id: excelDataParam[i]?.id ?? "",
			//   solutionName: excelDataParam[i]?.name?.input,
			//   vertical: excelDataParam[i]?.vertical?.input,
			//   module: excelDataParam[i]?.module?.input,
			//   subModule: excelDataParam[i]?.subModule?.input,
			//   shortDescription: excelDataParam[i]?.shortDescription?.input,
			//   version: excelDataParam[i]?.version,
			// };

			if (i === excelDataParam?.length - 1) {
				setNavigateTo('/comptroller/solution');
			}
			// await submitHandle(obj);
			// await delay(100);
		}
	};

	const onFieldsChange = (e) => {
		if (kmaDetails) {
			if (e[0]?.name[0] === 'name') {
				if (e[0]?.value !== kmaDetails?.name) {
					setCounter({
						...counter,
						name: 1,
					});
				} else {
					setCounter({
						...counter,
						name: 0,
					});
				}
			} else if (e[0]?.name[0] === 'moduleId') {
				if (e[0]?.value !== kmaDetails?.moduleId) {
					setCounter({
						...counter,
						moduleId: 1,
					});
				} else {
					setCounter({
						...counter,
						moduleId: 0,
					});
				}
			} else if (e[0]?.name[0] === 'subModuleId') {
				if (e[0]?.value !== kmaDetails?.subModuleId) {
					setCounter({
						...counter,
						subModuleId: 1,
					});
				} else {
					setCounter({
						...counter,
						subModuleId: 0,
					});
				}
			} else if (e[0]?.name[0] === 'parentKAMId') {
				if (e[0]?.value !== kmaDetails?.parentKAMId) {
					setCounter({
						...counter,
						parentKAMId: 1,
					});
				} else {
					setCounter({
						...counter,
						parentKAMId: 0,
					});
				}
			}
		} else {
			if (e[0]?.name[0] === 'moduleId') {
				if (e[0]?.value !== undefined) {
					setCounter({
						...counter,
						moduleId: 1,
					});
				} else {
					setCounter({
						...counter,
						moduleId: 0,
					});
				}
			} else if (e[0]?.name[0] === 'subModuleId') {
				if (e[0]?.value !== undefined) {
					setCounter({
						...counter,
						subModuleId: 1,
					});
				} else {
					setCounter({
						...counter,
						subModuleId: 0,
					});
				}
			} else if (e[0]?.name[0] === 'parentKAMId') {
				if (e[0]?.value !== undefined) {
					setCounter({
						...counter,
						parentKAMId: 1,
					});
				} else {
					setCounter({
						...counter,
						parentKAMId: 0,
					});
				}
			} else if (e[0]?.name[0] === 'name') {
				if (e[0]?.value !== '') {
					setCounter({
						...counter,
						name: 1,
					});
				} else {
					setCounter({
						...counter,
						name: 0,
					});
				}
			}
		}
	};

	const handleModalSubmit = (data) => {
		setSubmitData(data);
		setShowModal(true);

		if (kmaDetails) {
			setModalInfo({
				head: 'Key Management Area',
				action: 'update',
			});
		} else {
			setModalInfo({
				head: 'Key Management Area',
				action: 'submit',
			});
		}
	};

	const submitHandle = (data) => {
		if (data?.id) {
			updateKma({
				id: data?.id,
				name: data.name,
				code: data?.code,
				moduleId: data.moduleId,
				subModuleId: data.subModuleId,
				parentKAMId: data.parentKAMId,
				activationStatus: data?.activationStatus,
			});
		} else {
			addKma({
				name: data?.name,
				moduleId: data?.moduleId,
				subModuleId: data?.subModuleId,
				// parentKAMId: data?.parentKAMId,
				parentKAMId: data?.parentKAMId ? data?.parentKAMId : null,
				activationStatus: '',
			});
		}
	};

	useEffect(() => {
		if (state?.state) {
			setStateValues({
				kmaList: state?.state?.kmaList,
				kmaDetails: state?.state?.kmaDetails,
				solutionTable: state?.state?.solutionTable,
			});
		} else {
			navigate('/comptroller/solution');
		}
	}, [state?.state]);

	useEffect(() => {
		if (kmaDetails) {
			form.setFieldValue('id', kmaDetails?.id);
			form.setFieldValue('code', kmaDetails?.code);
			form.setFieldValue('name', kmaDetails?.name);
			form.setFieldValue('moduleId', kmaDetails?.moduleId);
			form.setFieldValue('subModuleId', kmaDetails?.subModuleId);
			form.setFieldValue('activationStatus', kmaDetails?.activationStatus);
			form.setFieldValue('parentKAMId', kmaDetails?.parentKAMId);
		}
	}, [stateValues]);

	useEffect(() => {
		getVerticalList({
			companyCode: profileData?.creatorOrganizationId,
		});

		getModuleList({});
	}, []);

	useEffect(() => {
		if (moduleList && !moduleOptions?.length) {
			const arr = [];

			for (let i = 0; i < moduleList?.listLynProcessModule?.length; i++) {
				if (moduleList?.listLynProcessModule[i]?.activationStatus === 'Active' && moduleList?.listLynProcessModule[i]?.parent === '') {
					arr.push(moduleList?.listLynProcessModule[i]);
				}
			}

			setModuleOptions(arr);
		}

		if (kmaList) {
			const arr = [];

			for (let i = 0; i < kmaList?.length; i++) {
				if (
					(kmaList[i]?.activationStatus?.toLowerCase() === 'active' || kmaDetails?.parentKAMId === kmaList?.[i]?.id) &&
					kmaDetails?.id !== kmaList[i]?.id
				) {
					arr.push({
						value: kmaList[i]?.id,
						label: kmaList[i]?.name,
					});
				}
			}

			setKmaListOption(arr);
		}

		if (kmaDetails && moduleList) {
			const arr = [];

			for (let i = 0; i < moduleList?.listLynProcessModule?.length; i++) {
				if (
					moduleList?.listLynProcessModule[i]?.activationStatus === 'Active' &&
					moduleList?.listLynProcessModule[i]?.parent === kmaDetails?.moduleId
				) {
					arr.push(moduleList?.listLynProcessModule[i]);
				}
			}
			setSubModule(arr);
		}
	}, [moduleList, verticalList, kmaList, kmaDetails]);

	useEffect(() => {
		if (name === 1 || moduleId === 1 || subModuleId === 1 || parentKAMId === 1) {
			setActivate(false);
		} else {
			setActivate(true);
		}
	}, [counter]);

	useEffect(() => {
		if (newKmaRes) {
			if (newKmaRes?.status === 'SUCCESS') {
				toast.success('Success! Action completed.', toastConfig);
				if (navigateTo) {
					navigate(navigateTo);
				}
			} else if (newKmaRes?.status === 'FAILED') {
				toast.error(updateKmaRes?.message, toastConfig);

				setSubmitForm(false);
				setSubmitData(null);
				setSubmitExcelData(null);
			}
		} else if (updateKmaRes) {
			if (updateKmaRes?.status === 'SUCCESS') {
				toast.success('Success! Action completed.', toastConfig);
				if (navigateTo) {
					navigate(navigateTo);
				}
			} else if (updateKmaRes?.status === 'FAILED') {
				toast.error(updateKmaRes?.message, toastConfig);

				setSubmitForm(false);
				setSubmitData(null);
				setSubmitExcelData(null);
			}
		}
	}, [updateKmaRes, newKmaRes]);

	useEffect(() => {
		if (submitForm) {
			setNavigateTo('/comptroller/key-management-area');

			submitHandle(submitData);
		} else if (submitExcelData) {
			handleExcel(submitExcelData);
		}
	}, [submitForm]);

	const childrenOne = (
		<Form
			form={form}
			id="coe-module"
			layout="vertical"
			onFieldsChange={onFieldsChange}
			onFinish={handleModalSubmit}
			autoComplete="off"
			requiredMark={false}
		>
			<Row gutter={[16, 0]}>
				<Form.Item className="animate__animated animate__fadeIn" hidden={true} name="id">
					<Input />
				</Form.Item>

				<Form.Item className="animate__animated animate__fadeIn" hidden={true} name="activationStatus">
					<Input />
				</Form.Item>

				<Col xs={24} sm={24} md={24} xl={24}>
					<Form.Item
						className="animate__animated animate__fadeIn"
						label="Module Name"
						name="moduleId"
						rules={[
							{
								required: true,
								message: 'Module is required',
							},
						]}
					>
						<Select
							allowClear
							showSearch
							style={{ width: '100%' }}
							filterOption={true}
							onChange={onChange}
							placeholder="Select from the list"
							optionFilterProp="children"
							autoComplete="off"
						>
							{moduleOptions?.map(({ id, name, code }) => (
								<Select.Option key={id} value={code}>
									{titleFormat(code, name)}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</Col>

				<Col xs={24} sm={24} md={24} xl={24}>
					<Form.Item
						className="animate__animated animate__fadeIn"
						label="Sub Module Name"
						name="subModuleId"
						rules={[
							{
								required: true,
								message: 'Sub Module is required',
							},
						]}
					>
						<Select
							allowClear
							showSearch
							style={{ width: '100%' }}
							filterOption={true}
							placeholder="Select from the list"
							optionFilterProp="children"
							autoComplete="off"
						>
							{subModule?.map(({ id, name, code }) => (
								<Select.Option key={id} value={code}>
									{titleFormat(code, name)}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</Col>

				<Col xs={24} sm={24} md={24} xl={24}>
					<Form.Item className="animate__animated animate__fadeIn" label="KMA Parent Name" name="parentKAMId" rules={[]}>
						<Select
							allowClear
							showSearch
							style={{ width: '100%' }}
							filterOption={true}
							placeholder="Select from the list"
							optionFilterProp="children"
							autoComplete="off"
						>
							{kmaListOption?.map(({ value, label }) => (
								<Select.Option key={value} value={value}>
									{label}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</Col>

				{kmaDetails && (
					<Col xs={24} sm={24} md={24} xl={24}>
						<Form.Item className=" animate__animated animate__fadeIn" label="Code" name="code" rules={[]}>
							<Input disabled={kmaDetails} placeholder="Enter Code Here" autoComplete="off" />
						</Form.Item>
					</Col>
				)}

				<Col xs={24} sm={24} md={24} xl={24}>
					<Form.Item
						name="name"
						label="KMA Name"
						className="animate__animated animate__fadeIn"
						rules={[
							{
								validator: validateInput,
							},
						]}
					>
						<Input placeholder="Type here" autoComplete="off" />
					</Form.Item>
				</Col>

				<Col xs={24} sm={24} md={24} xl={24}>
					<Flex style={{ margin: '10px' }} justify="flex-end" align="center">
						<Button
							disabled={activate}
							style={{ backgroundColor: activate ? '' : theme.palette.lynTheme.submit }}
							type="primary"
							htmlType="submit"
						>
							{kmaDetails ? 'Update' : 'Submit'}
						</Button>
					</Flex>
				</Col>
			</Row>
		</Form>
	);

	return (
		<>
			<Grid container rowSpacing={4.5} columnSpacing={2.75}>
				<Grid item xs={24} lg={24}>
					<Flex justify="flex-end" align="flex-end">
						<Button
							type="text"
							size="large"
							icon={<CaretLeftOutlined style={{ color: theme.palette.lynTheme.arrow }} />}
							onClick={() => {
								navigate(-1);
							}}
						></Button>
					</Flex>

					<Box sx={{ bgcolor: '#214689', borderRadius: 1, px: '10px', py: '10px', color: 'common.white' }}>
						<Stack direction="row" justifyContent="space-between" alignItems="center">
							<Stack direction="row" alignItems="center" sx={{ gap: '10px', textWrap: 'nowrap' }}>
								<img alt="comptroller" src={comptroller} width="18px" height="18px" />
								<Typography variant="h4">
									{kmaDetails ? 'Edit Key Management Area (KMA)' : 'Create Key Management Area (KMA)'}
								</Typography>
							</Stack>
						</Stack>
					</Box>
				</Grid>
			</Grid>

			<div style={{ marginTop: '1rem' }}>
				<MainCard sx={{ mt: 2 }}>{childrenOne}</MainCard>

				{showModal && (
					<ComptrollerConfirmModal showModal={showModal} setShowModal={setShowModal} setSubmitForm={setSubmitForm} modalData={modalInfo} />
				)}
			</div>
		</>
	);
}

export default COEKeyManagementArea;
